function FourOFour(){

    return(
        <div>
            <h1>Sorry, this page does not exist.</h1>
        </div>
    );
}

export default FourOFour;